"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editProduct = exports.mutateProducts = exports.MutateProducts = exports.MutateProductsActionTypes = exports.deleteProduct = exports.DeleteProduct = exports.DeleteProductActionTypes = exports.updateProduct = exports.UpdateProduct = exports.UpdateProductActionTypes = exports.createProductAndAddAnother = exports.CreateProductAndAddAnother = exports.CreateProductAndAddAnotherActionTypes = exports.createProduct = exports.CreateProduct = exports.CreateProductActionTypes = exports.fetchEditableTotal = exports.FetchEditableTotal = exports.FetchEditableTotalActionTypes = exports.fetchProduct = exports.FetchProduct = exports.FetchProductActionTypes = exports.ProductActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _utils = require("ReduxMessenger/utils");

var _fluxActions = require("flux-actions");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _I18n = _interopRequireDefault(require("I18n"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var getPayload = function getPayload(record) {
  var modifiedProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return record.properties.reduce(function (list, propertyValue, property) {
    return modifiedProperties === null || modifiedProperties.has(property) ? list.push({
      value: propertyValue.get('value'),
      name: property,
      'source-id': propertyValue.get('sourceId'),
      source: propertyValue.get('source')
    }) : list;
  }, (0, _immutable.List)());
};

var ProductActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_PRODUCT: null,
  FETCH_EDITABLE_TOTAL: null,
  CREATE_PRODUCT: null,
  CREATE_PRODUCT_AND_ADD: null,
  UPDATE_PRODUCT: null,
  DELETE_PRODUCT: null,
  MUTATE_PRODUCTS: null,
  EDIT_PRODUCT: null
}, 'products');
exports.ProductActionTypes = ProductActionTypes;
var FetchProductActionTypes = (0, _actions.createRequestTypes)(ProductActionTypes.FETCH_PRODUCT);
exports.FetchProductActionTypes = FetchProductActionTypes;
var FetchProduct = (0, _actions.createRequestActions)(FetchProductActionTypes);
exports.FetchProduct = FetchProduct;
var fetchProduct = (0, _fluxActions.createAction)(ProductActionTypes.FETCH_PRODUCT, function (query) {
  return query;
});
exports.fetchProduct = fetchProduct;
var FetchEditableTotalActionTypes = (0, _actions.createRequestTypes)(ProductActionTypes.FETCH_EDITABLE_TOTAL);
exports.FetchEditableTotalActionTypes = FetchEditableTotalActionTypes;
var FetchEditableTotal = (0, _actions.createRequestActions)(FetchEditableTotalActionTypes);
exports.FetchEditableTotal = FetchEditableTotal;
var fetchEditableTotal = (0, _fluxActions.createAction)(ProductActionTypes.FETCH_EDITABLE_TOTAL, function (query) {
  return query;
});
exports.fetchEditableTotal = fetchEditableTotal;
var CreateProductActionTypes = (0, _actions.createRequestTypes)(ProductActionTypes.CREATE_PRODUCT);
exports.CreateProductActionTypes = CreateProductActionTypes;
var CreateProduct = (0, _actions.createRequestActions)(CreateProductActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateProductActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text("sales.products.alerts.create.success")));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateProductActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text("sales.products.alerts.create.error")));
  }
});
exports.CreateProduct = CreateProduct;
var createProduct = (0, _fluxActions.createAction)(ProductActionTypes.CREATE_PRODUCT, function (product, userEmail, modifiedProperties, folderIdInView) {
  return {
    product: product,
    payload: getPayload(product),
    userEmail: userEmail,
    modifiedProperties: modifiedProperties,
    folderIdInView: folderIdInView
  };
});
exports.createProduct = createProduct;
var CreateProductAndAddAnotherActionTypes = (0, _actions.createRequestTypes)(ProductActionTypes.CREATE_PRODUCT_AND_ADD);
exports.CreateProductAndAddAnotherActionTypes = CreateProductAndAddAnotherActionTypes;
var CreateProductAndAddAnother = (0, _actions.createRequestActions)(CreateProductAndAddAnotherActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateProductAndAddAnotherActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text("sales.products.alerts.create.success")));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateProductAndAddAnotherActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text("sales.products.alerts.create.error")));
  }
});
exports.CreateProductAndAddAnother = CreateProductAndAddAnother;
var createProductAndAddAnother = (0, _fluxActions.createAction)(ProductActionTypes.CREATE_PRODUCT_AND_ADD, function (product, userEmail, modifiedProperties, folderIdInView) {
  return {
    product: product,
    payload: getPayload(product),
    userEmail: userEmail,
    modifiedProperties: modifiedProperties,
    folderIdInView: folderIdInView
  };
});
exports.createProductAndAddAnother = createProductAndAddAnother;
var UpdateProductActionTypes = (0, _actions.createRequestTypes)(ProductActionTypes.UPDATE_PRODUCT);
exports.UpdateProductActionTypes = UpdateProductActionTypes;
var UpdateProduct = (0, _actions.createRequestActions)(UpdateProductActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateProductActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text("sales.products.alerts.update.success")));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateProductActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text("sales.products.alerts.update.error")));
  }
});
exports.UpdateProduct = UpdateProduct;
var updateProduct = (0, _fluxActions.createAction)(ProductActionTypes.UPDATE_PRODUCT, function (product, userEmail, modifiedProperties, folderIdInView) {
  return {
    product: product,
    updates: getPayload(product, modifiedProperties),
    userEmail: userEmail,
    modifiedProperties: modifiedProperties,
    folderIdInView: folderIdInView
  };
});
exports.updateProduct = updateProduct;
var DeleteProductActionTypes = (0, _actions.createRequestTypes)(ProductActionTypes.DELETE_PRODUCT);
exports.DeleteProductActionTypes = DeleteProductActionTypes;
var DeleteProduct = (0, _actions.createRequestActions)(DeleteProductActionTypes);
exports.DeleteProduct = DeleteProduct;
var deleteProduct = (0, _fluxActions.createAction)(ProductActionTypes.DELETE_PRODUCT, function () {
  for (var _len = arguments.length, productIds = new Array(_len), _key = 0; _key < _len; _key++) {
    productIds[_key] = arguments[_key];
  }

  return productIds;
});
exports.deleteProduct = deleteProduct;
var MutateProductsActionTypes = (0, _actions.createRequestTypes)(ProductActionTypes.MUTATE_PRODUCTS);
exports.MutateProductsActionTypes = MutateProductsActionTypes;
var MutateProducts = (0, _actions.createRequestActions)(MutateProductsActionTypes, {
  successMetaCreator: function successMetaCreator(__action, _ref) {
    var type = _ref.type,
        expectedNumberObjectsModified = _ref.expectedNumberObjectsModified;
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(MutateProductsActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), {
      notification: (0, _utils.createSuccessNotification)(_I18n.default.text("sales.products.bulkUpdate." + type + ".success.title", {
        numberModified: expectedNumberObjectsModified
      }), _I18n.default.text("sales.products.bulkUpdate." + type + ".success.body"), false)
    });
  },
  failureMetaCreator: function failureMetaCreator(__action, _ref2) {
    var type = _ref2.type;
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(MutateProductsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text("sales.products.bulkUpdate." + type + ".failure")));
  }
});
exports.MutateProducts = MutateProducts;
var mutateProducts = (0, _fluxActions.createAction)(ProductActionTypes.MUTATE_PRODUCTS, _identity.default);
exports.mutateProducts = mutateProducts;
var editProduct = (0, _fluxActions.createAction)(ProductActionTypes.EDIT_PRODUCT, function (productId) {
  return productId;
});
exports.editProduct = editProduct;